import parse from 'html-react-parser'
import { EmptyCell, type IColumn, Typography } from 'shared/ui'
import { getLabelAsNumberInternationalFormat } from 'shared/lib'
import type { IResponseModifyCampaignContactState } from 'entities/Campaign'
import {
  getCellForName,
  getCellForTags,
} from 'widgets/ContactEnrollment/ui/EnrollmentContactsTable'
import type { IOpenContactsDetails } from 'widgets/ContactsDetails'
import { type ICampaignModelTable } from 'pages/campaigns/ui/detail/CampaignContactsStatisticsTable/model/types'
import { CampaignExecution } from 'pages/campaigns/ui/detail/CampaignContactsStatisticsTable/model/CampaignExecution'
import { CampaignQuietHoursMessage } from 'pages/campaigns/ui/detail/CampaignContactsStatisticsTable/model/CampaignQuietHoursMessage'
import styles from './styles.module.scss'

export const getColumns = (
  onOpenContactsDetails: IOpenContactsDetails,
  variant: 'overview' | 'step',
  isShowReply: boolean,
  activeFilter: IResponseModifyCampaignContactState | undefined
) => {
  const nameColumn: IColumn<ICampaignModelTable> = {
    field: 'full_name',
    name: 'Name',
    renderRowCell: (row, _, config) => {
      return getCellForName({
        row: row.contact,
        onOpenContactsDetails,
        config,
        inboxId: row.team_id,
      })
    },
  }

  const numberColumn: IColumn<ICampaignModelTable> = {
    field: 'number',
    name: 'Phone',
    renderRowCell: (row) =>
      row.contact.number && getLabelAsNumberInternationalFormat(row.contact.number),
  }

  const emailColumn: IColumn<ICampaignModelTable> = {
    field: 'email',
    name: 'Email',
  }

  const stepsCompleted: IColumn<ICampaignModelTable> = {
    field: 'steps_count',
    name: 'Steps completed',
  }

  const replied: IColumn<ICampaignModelTable> = {
    field: 'contact_has_replied',
    name: 'Replied',
    renderRowCell: (row) => (row.contact_has_replied ? 'Yes' : <EmptyCell />),
  }
  const tags: IColumn<ICampaignModelTable> = {
    field: 'tags',
    name: 'Tags',
    renderRowCell: (row) =>
      getCellForTags({
        tags: row.contact.tags,
        isDisabled: row.contact.isDisabled,
      }),
  }
  const failedReason: IColumn<ICampaignModelTable> = {
    field: 'failed_reason',
    name: 'Failed reason',
    renderRowCell: (row) => {
      if (row instanceof CampaignExecution) return null
      if (row instanceof CampaignQuietHoursMessage) return null

      return (
        <Typography
          className={styles.link}
          variant={'body-md-regular'}
          ariaLabel={'failed_reason_message'}
        >
          {parse(row.failed_reason)}
        </Typography>
      )
    },
  }

  const scheduledSendAt: IColumn<ICampaignModelTable> = {
    field: 'send_at',
    name: 'Scheduled send',
    renderRowCell: (row) => {
      if (row instanceof CampaignQuietHoursMessage) {
        return row.send_at
          ? new Date(row.send_at).toLocaleString(undefined, {
              dateStyle: 'short',
              timeStyle: 'short',
            })
          : null
      }
      return null
    },
  }

  let columns: IColumn<ICampaignModelTable>[] = []

  if (activeFilter === 'failed-messages') {
    return [nameColumn, numberColumn, emailColumn, failedReason]
  }
  if (activeFilter === 'quiet_hours') {
    return [nameColumn, numberColumn, emailColumn, scheduledSendAt]
  }

  if (variant === 'step') {
    return [nameColumn, numberColumn, emailColumn, tags]
  }

  columns = [nameColumn, numberColumn, emailColumn, stepsCompleted]

  if (isShowReply) {
    columns.push(replied)
  }

  return columns
}
